export const isInExtension = () => {
  try {
    return window.self !== window.top
      || window.location.protocol === 'chrome-extension:'
      || window.parent !== window
  }
  catch {
    return true
  }
}
